import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.JensenBlocklists = routerStyxie({ actions: ['edit']})
